import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ShipPageViajes, ShipPageData } from '@/types/dashboard/ShipPage';

// Modificar cuando tengamos una response de ejemplo

type GetShipPageResponse = {
  value: ShipPageData;
};

type ShipPageQueryType = {
  viaje: string;
  armador: string;
};

export const getDashboardShipPageData = async (
  query: ShipPageQueryType
): Promise<ShipPageData> => {
  try {
    const res = await apiClient.post<GetShipPageResponse>(
      Endpoints.DashboardShipPage,
      {
        viaje: query.viaje,
        armador: query.armador,
      }
    );
    return res.data.value || {};
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};

type GetShipPageViajesResponse = {
  value: ShipPageViajes[];
};

type ShipPageViajesQueryType = {
  armador: string;
};

export const getDashboardShipPageViajesData = async (
  query: ShipPageViajesQueryType
): Promise<ShipPageViajes[]> => {
  try {
    const res = await apiClient.post<GetShipPageViajesResponse>(
      Endpoints.DashboardBuqueViajes,
      query
    );
    return res.data.value || [];
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
